module.exports = __webpack_public_path__ + "img/light-f-fm-Path 51 Copy@3x.bed02763.png";